import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

export const UserProfileAvatar = styled(Box)(({ theme }) => ({
  width: 70,
  height: 70,
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: theme.palette.common.white,
  borderRadius: '50%',
  boxShadow: '0 0 4px rgba(0, 0, 0, 0.5)',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    width: 45,
    height: 45,
    '& img': {
      width: 41,
      height: 41
    }
  }
}))
